import React from 'react';
import { TYPE_COLORS } from '../../utils/constants';
import { formatRelative } from '../../utils/dates';
import Badge from '../shared/Badge';

function EntryRow({ entry, onClick, onRetry }) {
  const isClassified = !!entry.classification;
  const typeInfo = isClassified
    ? (TYPE_COLORS[entry.classification.entry_type] || TYPE_COLORS.otro)
    : null;

  function handleRetry(e) {
    e.stopPropagation();
    onRetry?.(entry);
  }

  return (
    <div className="list-row clickable entry-row" onClick={onClick}>
      <div className="list-row__main">
        <span className="list-row__title">
          {entry.content?.slice(0, 100)}{entry.content?.length > 100 ? '…' : ''}
        </span>
        <div className="list-row__meta">
          {isClassified ? (
            <>
              <span className="entry-status-badge entry-status-badge--done">✓ Procesado</span>
              <Badge label={typeInfo.label} color={typeInfo.color} />
              {entry.classification.project && (
                <span className="meta-chip">{entry.classification.project}</span>
              )}
            </>
          ) : (
            <span className="entry-status-badge entry-status-badge--pending">⏳ Sin clasificar</span>
          )}
          <span className="meta-chip">{formatRelative(entry.created_at)}</span>
        </div>
      </div>

      <div className="entry-row__actions" onClick={e => e.stopPropagation()}>
        {!isClassified && (
          <button className="btn-secondary entry-retry-btn" onClick={handleRetry}>
            ↩
          </button>
        )}
        <span className="entry-row__chevron">›</span>
      </div>
    </div>
  );
}

export default EntryRow;
